module.exports = __webpack_public_path__ + "img/border_rectangle3.74596733.svg";